<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    label="Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required
                  >
                  </v-text-field>

                  <v-textarea
                    label="Description(Optional)"
                    v-model="local.description">
                  </v-textarea>

                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>

                <v-flex>
                  <v-select
                    :items = "typeOfLights"
                    label = "Type of Light"
                    v-model = "local.typeOfLight"
                    :rules="generalRules"
                    required
                  ></v-select>
                  <v-select
                    :items = "shadowTypes"
                    label = "Select Shadow Type"
                    v-model = "local.shadowType"
                    :rules="generalRules"
                    required
                  ></v-select>
                  <v-text-field
                    v-model="local.duration"
                    label="Duration (sec)"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.target"
                    label="Target"
                    type="text">
                  </v-text-field>
                  <v-text-field
                    v-model="local.range"
                    label="Range"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.intensity"
                    label="Intensity"
                    type="text">
                  </v-text-field>
                  <v-text-field
                    v-model="local.shadowStrength"
                    label="Shadow Strength"
                    type="text">
                  </v-text-field>
                </v-flex>

                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>
                <v-flex>
                  <h3>Position of Origin</h3>
                  <v-text-field
                    v-model="local.positionOfOrigin.X"
                    label="Position of Origin Dimension X"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.positionOfOrigin.Y"
                    label="Position of Origin Dimension Y"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.positionOfOrigin.Z"
                    label="Position of Origin Dimension Z"
                    type="number">
                  </v-text-field>
                  <h3>Rotation of Origin</h3>
                  <v-text-field
                    v-model="local.rotationOfOrigin.X"
                    label="Rotation of Origin Dimension X"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.rotationOfOrigin.Y"
                    label="Rotation of Origin Dimension Y"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.rotationOfOrigin.Z"
                    label="Rotation of Origin Dimension Z"
                    type="number">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'

export default {
  // name: 'addCharacterModel',
  name: 'addOverlay',
  components: { ImageUploader, FileUploader },
  data: () => ({
    valid: true,
    saving: false,
    generalRules: [
      v => !!v || 'This field is required'
    ],
    typeOfLights: ['3D', 'Standalone', 'Character'],
    shadowTypes: ['test', 'testing shadow'],
    url: '',
    checkUrl: null,
    local: {
      id: null,
      name: '',
      duration: 0,
      typeOfLight: '3D',
      target: '',
      range: '',
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      intensity: '',
      shadowType: 'test',
      shadowStrength: '',
      description: '',
      image: null,
      typeOfImage: 'Background',
      videoLink: '',
      Media: {
        fileName: '',
        file: '',
        fileURL: ''
      }
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    info: {
      id: null,
      name: '',
      filename: '',
      service: '',
      description: '',
      image: null
    }
  },
  computed: {
    formTitle () {
      // return this.editedID === -1 ? 'New Character Model' : 'Edit Character Model'
      return this.editedID === -1 ? 'New Lighting' : 'Edit Lighting'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignImage (val) {
      this.local.image = val
    },
    open () {
      this.$emit('open')
    },
    close () {
      // console.log(`image: ${this.local.image.imageURL}`)
      // console.log(`imageFile: ${this.local.image.imageFile}`)
      this.$emit('close')
    },
    addURL () {
      let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      let objExp = new RegExp(Expression)
      if (objExp.test(this.url) === true) {
        this.checkUrl = true
        this.local.videoLink = this.url
        // this.url = ''
      } else {
        this.checkUrl = false
      }
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      // if (this.local.image === null) {
      //   flag = false
      //   this.errorMsg = 'Please add a picture'
      // }
      // if (this.typeOfMedia === 'video') {
      //   if (this.local.Media === {} && this.local.videoLink === null) {
      //     flag = false
      //     this.errorMsg = 'Please add a video file or video link'
      //   }
      // } else {
      //   if (this.local.Media === {}) {
      //     flag = false
      //     this.errorMsg = 'Please add a media file'
      //   }
      // }
      return flag
    },
    save () {
      console.log(true)
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      } else {
        console.log(false)
      }
    },
    assignFile (payload) {
      this.local.UI = payload
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addLighting.vue